import { SxProps, Theme } from '@mui/material';

import { panelSx } from '@/components/common/Panel/Panel.styles';

import { navigationHeight } from '@/utils/constants';

export const popoverPaperSx: SxProps<Theme> = theme => ({
  mt: 0.5,
  backgroundImage: 'none',
  border: 'none',
  ...(panelSx(theme as Theme) as object),
});

export const blurOverlaySx: SxProps<Theme> = {
  position: 'fixed',
  top: navigationHeight,
  left: 0,
  right: 0,
  bottom: 0,
  backdropFilter: 'blur(4px)',
  backgroundColor: 'transparent',
  zIndex: theme => (theme.zIndex.modal as number) - 1,
  pointerEvents: 'none',
};
